export const EnumSituacaoAgendamento = () => {
  return [
    { tipo: 'AGENDADO', descricao: 'Agendado' },
    { tipo: 'AGUARDANDO_ATENDIMENTO', descricao: 'Aguardando atendimento' },
    { tipo: 'EM_ATENDIMENTO', descricao: 'Em Atendimento' },
    { tipo: 'ATENDIDO', descricao: 'Atendido' },
    { tipo: 'NAO_COMPARECEU_FALTA_JUSTIFICADA', descricao: 'Não compareceu - Falta justificada' },
    { tipo: 'NAO_COMPARECEU_FALTA_INJUSTIFICADA', descricao: 'Não compareceu - Falta injustificada' },
  ];
};
